import { Col } from 'react-bootstrap';

import styles from './BriefingThumb.module.css';
import getExtension from '../../helpers/getExtension';

const BriefingThumb = props => {
  return (
    <Col sm={4}>
      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'pdf' &&
        <img
          src='../../assets/img/pdf.jpeg'
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && (getExtension(props.briefingArquivo.name) === 'doc' || getExtension(props.briefingArquivo.name) === 'docx') &&
        <img
          src='../../assets/img/word.png'
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && (getExtension(props.briefingArquivo.name) === 'xls' || getExtension(props.briefingArquivo.name) === 'xlsx') &&
        <img
          src='../../assets/img/excel.jpeg'
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'txt' &&
        <img
          src='../../assets/img/txt.png'
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'mp4' &&
        <img
          src='../../assets/img/mp4.png'
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'avi' &&
        <img
          src='../../assets/img/avi.png'
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'mov' &&
        <img
          src='../../assets/img/mov.png'
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo &&
        getExtension(props.briefingArquivo.name) !== 'pdf' &&
        getExtension(props.briefingArquivo.name) !== 'doc' &&
        getExtension(props.briefingArquivo.name) !== 'docx' &&
        getExtension(props.briefingArquivo.name) !== 'xls' &&
        getExtension(props.briefingArquivo.name) !== 'xlsx' &&
        getExtension(props.briefingArquivo.name) !== 'txt' &&
        getExtension(props.briefingArquivo.name) !== 'mp4' &&
        getExtension(props.briefingArquivo.name) !== 'avi' &&
        getExtension(props.briefingArquivo.name) !== 'mov' &&
        <img
          src={URL.createObjectURL(props.briefingArquivo)}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }
    </Col>
  );
};

export default BriefingThumb;
